export type SetIsKDSPage = {
	type: string;
	payload: {
		isKDSPage: boolean;
	};
};

export type SetPageName = {
	type: string;
	payload: {
		pageName: string;
	};
};

export const SET_IS_KDS_PAGE = 'set_is_kds_page';

export const SET_PAGE_NAME = 'set_page_name';

export const setIsKDSPage = (isKDSPage: boolean): SetIsKDSPage => {
	return { type: SET_IS_KDS_PAGE, payload: { isKDSPage } };
};

export const setPageName = (pageName: string): SetPageName => {
	return { type: SET_PAGE_NAME, payload: { pageName } };
};
